module.exports = "/images/vendor/flag-icon-css/flags/4x3/kw.svg?496fa4662f48d2d7e3bd946177905dc4";